module.exports = __webpack_public_path__ + "static/main-4ef518d83db5b9bf860ac6e1428fe1c0.png";